export default {
  tablist: {
    class: ['flex flex-1 border-b w-[80%]'],
  },
};
